import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import stringHelper from "../../../helpers/string-helper";
import associateServices from "../../../services";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import store from "../../../reducers/createReducers";
import DataActions from "../../../actions/data-actions";


const MiniBanners = () => {
    const {miniBannersR} = useSelector(state => state.dataReducer)
    const navigate = useNavigate()
    const {activeLanguage, agent} = useSelector(state => state.globalReducer)
    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const [loading, setLoading] = useState(false)
    const [banners, setMiniBanners] = useState([])

    useEffect(() => {
        if (!loading && !miniBannersR[`${activeLanguage?.key}|${agent?.isMobile ? 'mobile' : 'web'}`]) {
            setLoading(true)
            associateServices.getMiniBanners({
                language: activeLanguage?.key,
                device: agent?.isMobile ? 'mobile' : 'web',
            }).then(res => {
                store.dispatch(DataActions.setMiniBanners({
                    data: res?.data || [],
                    type: `${activeLanguage?.key}|${agent?.isMobile ? 'mobile' : 'web'}`
                }))
                setLoading(false)
            })

        }
    }, [activeLanguage?.key, agent?.isMobile, miniBannersR, loading])

    useEffect(() => {
        setMiniBanners(miniBannersR[`${activeLanguage?.key}|${agent?.isMobile ? 'mobile' : 'web'}`] || [])
    }, [miniBannersR])


    const handleNavigate = (path,basePath) => {
        if (!basePath)
            return false;

        if (basePath?.includes('https'))
            return window?.open(basePath, '_blank')

        navigate(path)
    }

    return (


        <div className="section" id="banners-wrapper">
            <div className="container d-flex flex-column gap-2">
                {
                    banners?.map(banner => <img
                        onClick={e => handleNavigate(stringHelper.getLocalizedPath(currentLanguage, banner?.path), banner?.path)}
                        key={banner?.id}
                        className={`w-100 h-100 rounded-3 ${banner?.path ? 'cursor-pointer' : ''}`}
                        src={banner?.image}
                        alt="Banner"/>)
                }
            </div>
        </div>


    )

}

export default MiniBanners
